/* Edits the state whenever siteId is changed */

export default function targetRevision(state = [], action) {
	switch (action.type) {
	case 'TARGET_REVISION' :
		return action.rev;

	default:
		return state;
	}
}
